<template>
  <div class="template">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'模板管理'}]"></breadcrumb>
    <div class="template-wrap">
      <div class="template-contain">
        <public-top-nav>
          <el-button @click="addTemplate()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新建模板</span>
          </el-button>
        </public-top-nav>
        <div class="template-table-wrap">
          <div class="template-table">
            <table>
              <tr v-for="(item,index) in templateList"
                  @click="editTemlate(index)"
                  :key="item.id">
                <td>{{item.name}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--出差报告-->
    <el-dialog width="740px"
               class="template_dialog"
               @close="formShow = ''"
               :visible="formShow==='出差报告'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>出差报告</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">出差日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">出差地点</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">出差期间主要拜访人员</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">工作内容及工作成效</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">下一步工作思路及拓展方向</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question last">需要解决的问题、支持及建议</div>
          <div class="template_dialog-item last"></div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--备忘录-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='备忘录'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>备忘录</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="height:200px"
               class="template_dialog-item_input">
            <div class="template_dialog-item_text">批示：</div>
            <div class="template_dialog-item_sign">签名：</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_input">题目：</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="height:200px"
               class="template_dialog-item_input last">内容：</div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--呈批件-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='呈批件'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>呈批件</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="height:200px"
               class="template_dialog-item_input">
            <div class="template_dialog-item_text">批示：</div>
            <div class="template_dialog-item_sign">签名：</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_input">题目：</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="height:200px"
               class="template_dialog-item_input last">内容：</div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--工作周报-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='工作周报'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>工作周报</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">凤凰卫视中文台、资讯台、电影台市场拓展</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">凤凰专区项目进展</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">新业务拓展</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question">与凤凰其他部门的合作及支持</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_question last">管理中心交办事物</div>
          <div class="template_dialog-item last"></div>
        </el-col>
      </el-row>
            <el-row>
        <el-col>
          <div class="template_dialog-item_question last">行业动态及建议</div>
          <div class="template_dialog-item last"></div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--外购礼品申请表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='外购礼品申请表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>外购礼品申请表</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">预算</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--外购礼品领用表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='自制礼品领用表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>自制礼品领用表</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">单价</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--名片申请表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='名片申请表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>名片申请表</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请数量</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_gray">名片资料</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item">姓名</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">职位</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">部门</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item">直线电话</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">总机及分机电话</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">传真</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item">手机</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">E-mail</div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item">网址</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="8">
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">备注</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--交际应酬申请表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='交际应酬申请表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>交际应酬费申请表（本市或外埠）</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">职位</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">应酬日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">总人数</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">应酬单位</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">应酬地点</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">预计金额</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">应酬目的</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">活动内容</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item">嘉宾姓名</div>
          <div class="template_dialog-item">嘉宾职务</div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item">内陪人员姓名</div>
          <div class="template_dialog-item">职位</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--请假申请表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='请假申请表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>考勤申请表</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">姓名</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">所属部门</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_gray">日常考勤申请</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">类型</div>
          <div class="template_dialog-item">病假/事假/产假/陪产假/婚假/丧假</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">请假日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_gray">休假申请</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">休假天数</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">尚余天数</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_title">休假时间</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item_gray">休假期间工作安排</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--办公用品领用表-->
    <el-dialog @close="formShow = ''"
               width="740px"
               class="template_dialog"
               :visible="formShow==='办公用品领用申请表'">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>办公用品领用表</div>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item">办公室用品名称</div>
          <div class="template_dialog-item">规格</div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">成本归属</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
        <el-col :span="12">
          <div class="template_dialog-item"></div>
          <div class="template_dialog-item"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-item_gray">审批流程</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="template_dialog-process">
            <el-select clearable
                       placeholder="请选择"
                       v-model="templateForm.processId">
              <el-option v-for="item in processList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitTemplate">确 认</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import publicTopNav from '@/components/publicTopNav'
import _ from 'lodash'
export default {
  components: {
    breadcrumb,
    publicTopNav
  },
  data() {
    return {
      formShow: '',
      templateList: [],
      processList: [],
      templateForm: {}
    }
  },
  created() {
    this.getList()
    this.getSelectList()
  },
  methods: {
    getList() {
      axios
        .get(api.templateAll)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取模板列表成功', res.data.result)
            this.templateList = res.data.result
            // let str = this.templateList[0].templateContent
            // console.log(JSON.parse(str))
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    getSelectList() {
      axios
        .get(api.processAll)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取审批流列表成功', res.data.result)
            this.processList = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    changePage() {},
    //添加模板
    addTemplate() {},
    //编辑模板
    editTemlate(index) {
      this.formShow = this.templateList[index].name
      this.templateForm = _.cloneDeep(this.templateList[index])
    },
    //提交编辑
    submitTemplate() {
      axios
        .post(api.addOrUpdate, this.templateForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '修改模板成功',
              type: 'success'
            })
            this.getList()
            this.formShow = ''
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.template {
  .template-wrap {
    padding: 77px 30px 0px 30px;
    .template-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .template-table-wrap {
        padding: 30px;
        .template-table {
          min-height: 470px;
          tr {
            cursor: pointer;
            height: 47px;
            td {
              padding: 0px 19px;
              div {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
  .template_dialog {
    .template_dialog-title {
      font-size: 26px;
      justify-content:center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .tempalte_dialog-title_img{
        width:50px;
        height: 50px;
        margin-right: 10px;

      }
    }
    .el-col {
      display: flex;
      &:last-child {
        border-right: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .dialog-footer {
      text-align: center;
    }
    .template_dialog-item,
    .template_dialog-item_title,
    .template_dialog-item_gray,
    .template_dialog-item_question,
    .template_dialog-item_input {
       white-space: pre-line;
      font-size: 16px;
      min-height: 44px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
      text-align: center;
      border-bottom: 0px;
      &.last {
        border-bottom: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .template_dialog-item_input {
      flex: 1;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .template_dialog-item_text {
        flex: 1;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .template_dialog-item_sign {
        align-self: flex-end;
        width: 100%;
        height: 50px;
        width: 180px;
        text-align: left;
      }
    }
    .template_dialog-process {
      height: 180px;
      font-size: 16px;
      flex: 1;
      line-height: 180px;
      text-align: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
    }
    .template_dialog-item {
      flex: 1;
    }
    .template_dialog-item_question {
      width: 300px;
      min-height: 100px;
    }
    .template_dialog-item_title {
      width: 110px;
    }
    .template_dialog-item_gray {
      background: #fafafa;
      flex: 1;
    }
  }
}
</style>
